import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ITestRepository from '../../2_domain/test/iTestRepository';
import { DefaultTestCategory, TestItemSummary } from '../../2_domain/test/test';
import Get from '../../lib/di/get';
import promiseResolver from '../../lib/util/promiseResolver';

const emptyPagination: Pagination = {
  isAscending: false,
  pageNumber: 0,
  pageSize: 20,
};

const emptyPageResult: Page = {
  totalElements: 0,
  pageNumber: 0,
};

const useTestInformationPageController = () => {
  const testRepo = Get.find<ITestRepository>('ITestRepository');
  const [pagination, setPagination] = useState<Pagination>(emptyPagination);
  const [pageResult, setPageResult] = useState(emptyPageResult);
  const [selectedCategory, setSelectedCategory] = useState<Category>();
  const [searchText, setSearchText] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const [testItems, setTestItems] = useState<TestItemSummary[]>([]);
  const navigate = useNavigate();

  const setPageNumber = (newPageNumber: number) => {
    setPagination((prev) => {
      return { ...prev, pageNumber: newPageNumber };
    });
  };

  const setPageSize = (newPageSize: number) => {
    setPagination((prev) => {
      return { ...prev, pageSize: newPageSize };
    });
  };

  const onReset = () => {
    setPagination(emptyPagination);
    setPageResult(emptyPageResult);
    setSelectedCategory(undefined);
    setSearchText('');
  };

  const loadTestItems = () =>
    promiseResolver({
      promise: testRepo.getTestItemSummaries(
        searchText,
        selectedCategory ?? DefaultTestCategory
      ),
      successCallback: (data) => {
        setTestItems(data);
      },
      isLoadingCallback: setIsLoading,
    });

  const onClickSearchHandler = () => {
    loadTestItems();
  };

  const navigateToTestItemDetail = (test: TestItemSummary) => () => {
    navigate(`${test.serial}`);
  };

  useEffect(() => {
    loadTestItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    onReset,
    pagination,
    isLoading,
    setIsLoading,
    searchText,
    setSearchText,
    selectedCategory,
    setSelectedCategory,
    setPagination,
    pageResult,
    setPageResult,
    setPageNumber,
    setPageSize,
    onClickSearchHandler,
    navigateToTestItemDetail,
    testItems,
  };
};

export default useTestInformationPageController;
